module.exports = __webpack_public_path__ + "static/media/event3-home.caabbe94.jpg";